module.exports = __webpack_public_path__ + "static/media/location-maps-letter-j-arrow.07ec0802.png";